<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :is_show_chart_dialog="is_show_chart_dialog"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-if="enable_route_filter" v-slot:filter_condition_options>
            <MonitorOptionSet
                :option_set="option_set"
                @filter_data="filter_data"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_draw_diagram_header="should_draw_diagram_header"
                :should_display_info_header_key_value="should_display_info_header_key_value"
                :generate_tooltop_display_info="generate_tooltop_display_info"
                :enable_diagram_slot="true"
                :show_footer="false"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
                @open-chart="assign_chart_component"
                :is_show_chart_dialog_parent.sync="is_show_chart_dialog"
            >
                <template v-slot:diagram_dialog="{ close_dialog }">
                    <template v-if="is_show_chart_dialog">
                        <!-- 雨量站統計的 component -->
                        <template v-if="should_draw_stations_diagram_header.includes(current_table_header)">
                            <MonitorStations
                                :station_data="immutable_table_data"
                                :zone_span="current_table_header"
                                :zone_table_value="current_choosed_table_value"
                                :date="date"
                                :time="time"
                                @close-chart-dialog="close_dialog"
                            />
                        </template>
                        <!-- 時間軸的 component -->
                        <template v-if="should_draw_timeseries_diagram_header.includes(current_table_header)">
                            <GisChart
                                id="belongs_monitor_chart"
                                :chart_options="chart_options"
                                :default_variable="$t('__rainfall.rainfall')"
                                :prop_rain_selected="current_table_header"
                                :rain_period_options="rain_period_options"
                                @close-chart-dialog="close_dialog"
                            />
                        </template>
                    </template>
                </template>
                <template v-slot:table_description>
                    <span>
                        說明："--"標示，顯示該欄位無資料。 
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax} from "@/utils/monitor/monitor.js"
    import { get_stations_history_params } from "@/utils/chart/chart_ajax.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { mapState } from 'vuex'
    import {
        TABLE_VALUE_TEXT_MAPPING,
        TELEPHONE_WORK_BRANCH, TELEPHONE_POLICE_STATION
    } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorOptionSet from "@/components/monitor/monitor_option_set.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

	export default {
        name: 'child_route_rainfall',

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorOptionSet, 
            QpeDatatable, 
            MonitorStations: () => import("@/components/chart/monitor_stations.vue"), 
            GisChart: () => import("@/components/chart/gis_chart.vue")
        },

        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                required: true,
            },

            option_local_storage_name: {
                type:String,
                required: true,
            },

            enable_route_filter: {
                type: Boolean,
                default: true,
            },
        },
        
        data() {
            return {
                header: [],
                table_data: [],
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_route: '所有路線',

                should_draw_diagram_header: ['路線', '工務段', '分駐所', '10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '72小時'],
                should_draw_stations_diagram_header: ['路線', '工務段', '分駐所'],
                should_draw_timeseries_diagram_header: ['10分鐘', '1小時', '3小時', '6小時', '12小時', '24小時', '72小時'],
                should_display_info_header_key_value: {
                    '分駐所': {
                        'display_data_prefix_content': '電話:', 
                        'display_data_mapping': TELEPHONE_POLICE_STATION
                    },
                    '工務段': {
                        'display_data_prefix_content': '電話:',
                        'display_data_mapping': TELEPHONE_WORK_BRANCH
                    }
                },

                current_table_header: '',
                current_choosed_table_value: '',
                history_data_loaded: false,
                is_show_chart_dialog: false,
                chart_options: {
                    type: { 'gauge': true }
                },

                TABLE_VALUE_TEXT_MAPPING: TABLE_VALUE_TEXT_MAPPING,
            }
        },
        
        computed: {
            ...mapState([
                'client_name'
            ]),
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            // 只保留該表格實際存在的欄位時距，避免時序圖下拉選單出現表格沒有的時距選項
            rain_period_options() {
                const table_header_texts = this.header.map(item => item.text)
                return this.should_draw_timeseries_diagram_header.filter(period => table_header_texts.includes(period))
            },
        },
        
        watch: {
            immutable_table_data() {
                if (this.immutable_table_data && this.enable_route_filter) {
                    this.init_option_set()
                    this.update_option_set_from_local_storage()
                }
            },
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data (data, header) {
                const filter_afr_data = (data) => {
                    if (this.client_name === 'AFR') {
                        return data.filter(datum => datum['路線'].includes('阿里山'))
                    }

                    return data
                } 
                this.immutable_table_data = filter_afr_data(data);
                this.table_data = filter_afr_data(data);
                this.header = header;
            },

            init_option_set () {  
                const option_set_array = [
                    {current_option_value: this.display_all_route, json_key:'路線', label: 'route' },
                ]
                
                option_set_array.forEach(item => {
                    if(!item.option_array || item.option_array.length == 1) {
                        item.option_array = this.table_data.map(item2 => item2[item.json_key])
                        item.option_array = [item.current_option_value, ...new Set(item.option_array)]
                    }
                })
                
                this.option_set = option_set_array
            },
            
            filter_data (filtered_cond) {
                if (this.option_set[0].current_option_value != filtered_cond['route']) {
                    this.option_set[0].current_option_value = filtered_cond['route']
                }
                
                let compare_route
                filtered_cond['route'] === this.display_all_route ? compare_route = '' : compare_route = filtered_cond['route']
        
                let filtered_data = this.immutable_table_data.filter(item => item['路線'].includes(compare_route))
                this.table_data = filtered_data    

                // 把目前選擇的 option 存起來
                localStorage.setItem(this.option_local_storage_name, JSON.stringify(filtered_cond))            
            },   
            
            update_option_set_from_local_storage() {
                const child_route_rainfall_option = JSON.parse(localStorage.getItem(this.option_local_storage_name))
                if (child_route_rainfall_option && Object.keys(child_route_rainfall_option).length !== 0) {
                    this.option_set[0].current_option_value = child_route_rainfall_option.route
                }
            },

            assign_chart_component(header_name, choosed_value, current_row_data) {
                this.current_table_header = header_name
                this.current_choosed_table_value = choosed_value
                if(this.should_draw_timeseries_diagram_header.includes(header_name)) {
                    this.chart_options = { ...this.chart_options, ...get_stations_history_params.call(this, current_row_data) }
                }
            },
            
            generate_tooltop_display_info (row, column_name) {
                if (this.should_display_info_header_key_value[column_name].display_data_mapping[row[column_name]]) {
                    return `${column_name}${this.should_display_info_header_key_value[column_name].display_data_prefix_content} 
                    ${this.should_display_info_header_key_value[column_name].display_data_mapping[row[column_name]]}`
                }else{
                    return `${column_name}${this.should_display_info_header_key_value[column_name].display_data_prefix_content} 暫無電話資料`
                }
            },
        },
	}
</script>

<style>
</style>